import { jwtAuthAxios } from "../../shared/utils/network-utils";

export const AdminMigrationApi = {
  reCalculateRaScores: async () =>
    await jwtAuthAxios().post<void>(`/admin/migrations/re-calculate-ra-scores`),

  migrateHlaWays: async () =>
    await jwtAuthAxios().post<void>(`/admin/migrations/migrate-hla-ways`),

  migrateHlaWay: async (id: string) =>
    await jwtAuthAxios().post<void>(`/admin/migrations/migrate-hla-way/${id}`),
};

